import { render, staticRenderFns } from "./NText.vue?vue&type=template&id=0f3d42e7"
import script from "./NText.vue?vue&type=script&lang=js"
export * from "./NText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports